import React, { useState, useEffect } from "react";

const useResponsiveState = () => {
  /* Boundaries match design.md §8 and the CSS media queries exactly:
     mobile < 768 · tablet 768–1024 · desktop >= 1025. 1024 is tablet on
     both sides — CSS says `max-width: 1024px`, so this must too. */
  const getViewType = (width) => {
    if (width < 768) return "mobile";
    if (width < 1025) return "tablet";
    return "desktop";
  };

  const getInitialState = (viewType) => {
    switch (viewType) {
      case "mobile":
        return {
          /* mobile-specific initial state */
        };
      case "tablet":
        return {
          /* tablet-specific initial state */
        };
      default:
        return {
          /* desktop-specific initial state */
        };
    }
  };

  const [viewType, setViewType] = useState(() => {
    if (typeof window !== "undefined") {
      return getViewType(window.innerWidth);
    }
    return "desktop";
  });

  const [data, setData] = useState(() => getInitialState(viewType));

  useEffect(() => {
    const handleResize = () => {
      setViewType(getViewType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { viewType, data };
};

export default useResponsiveState;
